export default __webpack_public_path__ + "static/media/Placeholder.553ba992.svg";